// ─── Darstellung von Zahlen ─────────────────────────────────────────────────

/**
 * Bytes in eine Größe, die man vorlesen kann.
 *
 * Bewusst nicht stur in einer Einheit: 256 MB als „0,3 GB" zu schreiben
 * stimmt zwar, liest sich aber wie ein Fehler.
 */
export function groesse(n: number): string {
  if (n < 1024) return `${n} B`;
  const einheiten = ['KB', 'MB', 'GB', 'TB'];
  let wert = n / 1024;
  let i = 0;
  while (wert >= 1024 && i < einheiten.length - 1) {
    wert /= 1024;
    i++;
  }
  return `${wert.toFixed(wert < 10 ? 1 : 0).replace('.', ',')} ${einheiten[i]}`;
}
